/* eslint-disable max-len */
/* eslint-disable no-console */
import { useDispatch, useSelector } from 'react-redux';
import { catchErr } from '../../../libs/HelperContent';
import { useContext } from 'react';
import { MediaContext } from '..';
import { getEmployeeData } from '../../actions/media_actions';
import { setMediaKitData } from '../../../redux/MediakitRedux';

const useGetEmployeList = () =>
{
	const { mediaState, setMediaState } = useContext(MediaContext);
	const { employeeData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const itemsPerPage = 12;
	const dispatch = useDispatch();
	const getEmployeList = async () =>
	{
		const query:any = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role,
			limit   : itemsPerPage,
			skip    : mediaState?.page

		};
		const getEmployesCount = async () =>
		{
			query.count = 'true';
			try
			{
				const res = await getEmployeeData(query);

				if (res?.status)
				{
					setMediaState({ type: 'setCount', payload: { employee: res?.count } });
				}
			}
			catch (err)
			{
				console.log('*****err');
				catchErr(err);
			}
		};

		try
		{
			if (mediaState?.searchValue !== '')
			{
				query.search = mediaState?.searchValue;
			}
			mediaState?.page === 0 && (employeeData?.length === 0 || !employeeData[0]?.ownerName || mediaState?.searchValue) && setMediaState({ type: 'updateReducer', payload: { loading: true } });

			const res = await getEmployeeData(query);

			if (res?.status)
			{
				dispatch(setMediaKitData({ employeeData: mediaState?.page === 0 ? res?.data : [ ...employeeData, ...res.data ] }));

				if (mediaState?.page === 0 && res?.data?.length >= itemsPerPage)
				{
					getEmployesCount();
				}
				else
				{
					setMediaState({ type: 'setCount', payload: { employee: res?.data?.length } });
				}
				setMediaState({ type: 'updateReducer', payload: { loading: false } });
			}
		}
		catch (err)
		{
			console.log(err);
			catchErr(err);
			setMediaState({ type: 'updateReducer', payload: { loading: false } });
		}
	};

	return getEmployeList;
};

export default useGetEmployeList;